import { Box, Stack, Typography } from "@mui/material";
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";

const NullCheck = ({ children, valueForCheck, nullToDiv, noData }) => {
  const { bt } = useBizTypeTranslation();
  return valueForCheck && valueForCheck !== null
    ? children
    : nullToDiv
      ? <Box></Box>
      : noData
        ? <Stack justifyContent='center' alignItems='center' height='100%'>
          <Typography>{bt('NO_DATA')}</Typography>
        </Stack>
        : null;
};
export default NullCheck;
